import { render, staticRenderFns } from "./JobGroupKanbanPage.vue?vue&type=template&id=508dd383&scoped=true"
import script from "./JobGroupKanbanPage.vue?vue&type=script&lang=js"
export * from "./JobGroupKanbanPage.vue?vue&type=script&lang=js"
import style0 from "./JobGroupKanbanPage.vue?vue&type=style&index=0&id=508dd383&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508dd383",
  null
  
)

export default component.exports